'use client'

import SectionLayout from '@component/layout/section'
import Tooltip from '@component/tooltip'
import getRouter, { URLS } from '@router'
import { get, map, size } from 'lodash-es'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import Image from 'next/image'
import useViewAll from '@hooks/useViewAll'
import classNames from 'classnames'
import GoogleAdvert from '@component/google/advert'
import { isEstimateData } from '@utils/house'
import { useEffect, useState } from 'react'
import { IS_SERVER } from '@config'
import { useRecoilValue } from 'recoil'
import { global } from '@store/index'

export default function PropertyData({
  data
}) {

  const list = get(data, 'publicRecords.data')
  const [viewData, ToggleButton, displayAll] = useViewAll(list, 4)
  const isEstimate = isEstimateData(data)
  const showSubAd = get(data, 'publicRecords.showFirstGasAd', false)

  const { isMobile } = useRecoilValue(global)
  const [isServer, setIsServer] = useState(true)
  useEffect(() => setIsServer(IS_SERVER), [setIsServer])

  return size(list) > 0 && (
    <SectionLayout
      title={
        <>
          Property data
          <Tooltip
            bottom
            contentClassName='rounded-sm'
            content={
              <div className='text-sm text-font p-16 w-330'>This data may be sourced from your Councils, Regional Councils or other Local Authorities across NZ. Click <DisablePrefetchLink href={getRouter(URLS.disclaimer)} className='text-primary underline' target='_blank'>here</DisablePrefetchLink> for more detail or please contact your Local Authority for clarification/correction.</div>
            }
          >
            <i className='icon icon-info !text-sm ml-4 text-secondary align-middle'></i>
          </Tooltip>
        </>
      }
    >
      <div className={classNames('grid gap-20 grid-cols-1', { 'md:grid-cols-[1fr,auto]': isEstimate })}>
        <div className='min-w-0'>
          <div className={classNames('grid gap-24', isEstimate ? 'grid-cols-2' : 'grid-cols-1 sm:grid-cols-2')}>
            {
              map(viewData, item => (
                <DataItem data={item} key={item.alias}></DataItem>
              ))
            }
          </div>
          {
            !displayAll && (
              <ToggleButton className='button-primary-out mt-28 w-full !text-base sm:w-160' arrow></ToggleButton>
            )
          }
        </div>
        {
          isEstimate && (<GoogleAdvert id='property-data-right-ad' adsize={[[300, 250], ["fluid"]]} adunit='rectangle' adpos='4'></GoogleAdvert>)
        }
      </div>
      {
        isEstimate && showSubAd && !isServer && (
          <div className='mt-16'>
            {
              isMobile
                ? <GoogleAdvert id='property-data-sub-ad-mobile' adsize={[300, 250]} adunit='rectangle'></GoogleAdvert>
                : <GoogleAdvert id='property-data-sub-ad-desktop' adsize={[[970, 250], [728, 90]]} adunit='leaderboard'></GoogleAdvert>
            }
          </div>
        )
      }
    </SectionLayout>
  )
}

const fgLink = 'https://firstgas.co.nz/benefits-of-gas/?utm_source=dv360&utm_medium=consideration-partnership&utm_content=oneroof_utilities_icon&utm_campaign=wat-always_on_2022-fg0005'
const nzgbcLink = 'https://www.nzgbc.org.nz/Category?Action=View&Category_id=206'
function DataItem({
  data
}) {

  const isFg = data.alias === 'fg'
  const ItemTag = isFg ? DisablePrefetchLink : 'div'
  return (
    <ItemTag href={isFg ? fgLink : undefined} className='flex items-center'>
      {
        data.ossImage && (
          <Image src={data.ossImage} alt={data.label} width={40} height={40} unoptimized></Image>
        )
      }
      <div className='flex-1 ml-16 text-font'>
        <div className='text-lg'>
          {data.label}
          {
            data.alias === 'nzgbc' && (
              <Tooltip
                bottom
                contentClassName='rounded-sm'
                content={
                  <div className='text-sm text-font p-16 w-330'>Homestar is a green, healthy home rating certification, awarded on a scale from 6 to 10, run by the not-for-profit Green Building Council - click <DisablePrefetchLink href={nzgbcLink} className='text-primary underline' target='_blank' rel='noreferrer'>here</DisablePrefetchLink> for more details.</div>
                }
              >
                <i className='icon icon-info !text-sm ml-4 text-secondary align-middle'></i>
              </Tooltip>
            )
          }
        </div>
        <div className='text-sm' dangerouslySetInnerHTML={{ __html: data.value || '' }}></div>
      </div>
    </ItemTag>
  )
}